// 班期管理
import request from '@/utils/request6'

// 新增班期
export function addDeliverySchedule(data) {
  return request({
    url: '/cloud/delivery/schedule',
    method: 'POST',
    data
  })
}
// 编辑班期
export function editDeliverySchedule(data) {
  return request({
    url: '/cloud/delivery/schedule',
    method: 'PUT',
    data
  })
}
// 成本详情
export function getDeliveryScheduleCost(scheduleId) {
  return request({
    url: `/cloud/delivery/schedule/cost/${scheduleId}`,
    method: 'get'
  })
}
// 班期详情
export function getDeliveryScheduleDetail(id) {
  return request({
    url: `/cloud/delivery/schedule/detail/${id}`,
    method: 'get'
  })
}

/**
 * 批量查询班期信息（只返回班期表本身的字段：scheduleNum 班期名、scheduleStatus 状态（1未开班 2已开班 3已完结）、
 * deliveryStartTime/deliveryEndTime 交付开始/结束时间、type 班期类型（1线下课 2直播课）等）
 * @param {Array} ids 班期id列表
 */
export function getDeliveryScheduleDetailBatch(ids) {
  return request({
    url: '/cloud/delivery/schedule/detail/batch',
    method: 'get',
    params: { ids: (ids || []).join(',') }
  })
}

// 老师验证
export function verifyCheckTeacher(data) {
  return request({
    url: `/cloud/delivery/schedule/check/teacher`,
    method: 'POST',
    data
  })
}

// 查询学员入班数
export function queryCheckNum(data) {
  return request({
    url: `/cloud/delivery/schedule/check/num`,
    method: 'POST',
    data
  })
}

// 分页查询班期列表
export function getDeliveryScheduleList(data) {
  return request({
    url: '/cloud/delivery/schedule/page',
    method: 'post',
    data
  })
}

// 分页部门查询班期列表
export function getDeliveryDepartmentScheduleList(data) {
  return request({
    url: '/cloud/delivery/schedule/department/page',
    method: 'post',
    data
  })
}

// 记录成本
export function getDeliveryScheduleRecordCost(data) {
  return request({
    url: '/cloud/delivery/schedule/record/cost',
    method: 'put',
    data
  })
}
// 分页查询签到码
export function getDeliveryScheduleSignQrcodeList(id) {
  return request({
    url: `/cloud/delivery/schedule/sign/qrcode/${id}`,
    method: 'get'
  })
}
// 删除班期
export function delDeliverySchedule(id) {
  return request({
    url: `/cloud/delivery/schedule/${id}`,
    method: 'DELETE'
  })
}

// 班期的学员记录
export function getSignPage(params) {
  return request({
    url: '/cloud/delivery/schedule-student/page',
    method: 'GET',
    params
  })
}

// 我的分页查询
export function getScheduleMyPage(data) {
  return request({
    url: '/cloud/delivery/schedule/my/page',
    method: 'post',
    data
  })
}

// 分页查询班级详情列表
export function getScheduleClassPage(data) {
  return request({
    url: '/cloud/delivery/schedule/detail/page',
    method: 'POST',
    data
  })
}

// 班期的学员记录
export function getScheduleStudentPage(params) {
  return request({
    url: '/cloud/delivery/schedule-student/page',
    method: 'GET',
    params
  })
}
// 班期的学员记录
export function getScheduleStudentPageByDay(params) {
  return request({
    url: '/cloud/delivery/schedule-student/page-by-day',
    method: 'GET',
    params
  })
}
// 导出班期的学员记录
export function scheduleStudentExport(params) {
  return request({
    url: '/cloud/delivery/schedule-student/export',
    method: 'POST',
    data: params
  })
}

// 班期的学员操作记录
export function getAuditlog(params) {
  return request({
    url: '/cloud/delivery/schedule/auditlog/query',
    method: 'GET',
    params
  })
}

// 成本确认
export function confirmCost(scheduleId) {
  return request({
    url: `/cloud/delivery/schedule/confirm/cost/${scheduleId}`,
    method: 'PUT'
  })
}

// 获取班期的场次列表
export function getScheduleSessionList(scheduleId) {
  return request({
    url: `/cloud/delivery/schedule-session/list/simple/${scheduleId}`,
    method: 'get'
  })
}

// 根据商品获取班期列表
export function getScheduleListByGoodsId(goodsId) {
  return request({
    url: `/cloud/delivery/schedule/list/${goodsId}`,
    method: 'get'
  })
}

// 根据班期获取班主任列表
export function getHeadteacherListByShceduleId(shceduleId) {
  return request({
    url: `/cloud/delivery/schedule-headteacher/list/${shceduleId}`,
    method: 'GET'
  })
}

// 签到记录分页
export function getScheduleSignPage(params) {
  return request({
    url: '/cloud/delivery/schedule-sign/schedule/page',
    method: 'GET',
    params
  })
}

// 商品班期上一次的地点
export function getLastDistrict(goodsId) {
  return request({
    url: `/cloud/delivery/schedule/last/district/${goodsId}`,
    method: 'GET'
  })
}

// 获取当前班期未交付学员
export function getUndeliveredUserNameList(scheduleId) {
  return request({
    url: `/cloud/delivery/schedule/record/cost/${scheduleId}`,
    method: 'GET'
  })
}

// 删除助教校验
export function deleteAssistantCheck(data) {
  return request({
    url: '/cloud/admin/material/goods/deleteAssistantCheck',
    method: 'POST',
    data
  })
}

// 获取空降学员列表
export function getAirborneStudentPageAjax(params) {
  return request({
    url: '/cloud/delivery/delivery-info/airborne/student/page',
    method: 'GET',
    params
  })
}

// 新增空降学员
export function addAirborneStudentAjax(data) {
  return request({
    url: '/cloud/delivery/delivery-info/add/airborne/student',
    method: 'POST',
    data
  })
}

export function deliveryScheduleLogo(data) {
  return request({
    url: `/cloud/delivery/schedule-session/sign/logo/${data.scheduleId}`,
    method: 'POST',
    data
  })
}
// 预览班期签到logo
export function deliveryScheduleLogoView(data) {
  return request({
    url: `/cloud/delivery/schedule-session/sign/logo/view`,
    method: 'POST',
    data
  })
}

export function deliveryInfoExportV2(data) {
  return request({
    url: `/cloud/delivery/delivery-info/export/v2`,
    method: 'POST',
    data
  })
}

export function deliveryPage(params) {
  return request({
    url: `/cloud/delivery/delivery-info/detail/delivery/page`,
    method: 'get',
    params
  })
}

// 班期管理-直播课-班期详情-学员列表
// /cloud/delivery/live/delivery/page/{type}
export function getLiveDeliveryPage(type, data) {
  return request({
    url: `/cloud/delivery/live/delivery/page/${type}`,
    method: 'POST',
    data
  })
}

// 更新排序
export function scheduleSort(data) {
  return request({
    url: `/cloud/delivery/schedule/course/batch/sort`,
    method: 'POST',
    data
  })
}
// 批量更新积分
export function batchUpdatePoint(data) {
  return request({
    url: `/cloud/delivery/schedule/course/batch/pointValue`,
    method: 'POST',
    data
  })
}
// 学习完成百分比
export function getCompletionRatio(scheduleId) {
  return request({
    url: `/cloud/delivery/schedule/detail/getCompletionRatio?scheduleId=${scheduleId}`,
    method: 'get'
  })
}
// 修改学习完成百分比
export function updateCompletionRatio(data) {
  return request({
    url: `/cloud/delivery/schedule/detail/updateCompletionRatio`,
    method: 'POST',
    data
  })
}

// 分页查询班主任
export function scheduleTeacherList(params) {
  return request({
    url: `/cloud/delivery/schedule/teacher/page`,
    method: 'get',
    params
  })
}
// 创建班主任
export function addDeliveryTeacher(data) {
  return request({
    url: `/cloud/delivery/schedule/teacher`,
    method: 'POST',
    data
  })
}
// 删除班主任
export function delDeliveryTeacher(id) {
  return request({
    url: `/cloud/delivery/schedule/teacher/${id}`,
    method: 'DELETE'
  })
}

// 更新班主任
export function updateDeliveryTeacher(data) {
  return request({
    url: `/cloud/delivery/live/delivery/update/teacher`,
    method: 'POST',
    data
  })
}
// 模糊查询班主任列表
export function scheduleTeacherPage(params) {
  return request({
    url: `/cloud/delivery/schedule/teacher/list`,
    method: 'get',
    params
  })
}
// 章节拖动排序
export function scheduleMoveSort(data) {
  return request({
    url: `/cloud/delivery/schedule/course/move/sort`,
    method: 'POST',
    data
  })
}
//
export function deliveryLiveScheduleStudentExport(data) {
  return request({
    url: `/cloud/delivery/live/delivery/export`,
    method: 'POST',
    data
  })
}

// 结算
export function updateSettlementStatus(data) {
  return request({
    url: `/cloud/delivery/live/delivery/updateSettlementStatus`,
    method: 'POST',
    data
  })
}

// 分页查询学习进度
export function getLearningProgressPage(data) {
  return request({
    url: '/cloud/delivery/user-material-stats/learningProgress/page',
    method: 'POST',
    data
  })
}

// 导出学习进度
export function exportLearningProgress(data) {
  return request({
    url: '/cloud/delivery/user-material-stats/learningProgress/export',
    method: 'POST',
    data
  })
}

// 批量发送学习提醒
export function sendLearningRemind(data) {
  return request({
    url: '/cloud/delivery/aftersale-remind/send-course-remind',
    method: 'POST',
    data
  })
}

// 兑换学员班期积分
export function exchangeStudentPoints(data) {
  return request({
    url: '/cloud/delivery/user-point-detail/exchange',
    method: 'POST',
    data
  })
}

// 取消课程权限（直播课班期学员）
export function cancelSchedulePermission(data) {
  return request({
    url: '/cloud/delivery/live/delivery/cancelPermission',
    method: 'POST',
    data
  })
}

// 导出班期学员看课记录
export function exportScheduleUserProgress(data) {
  return request({
    url: '/cloud/admin/export/user/progress/live/exportStudyRecord',
    method: 'POST',
    data
  })
}

// 批量导入学员 - 解析Excel获取总条数
export function parseImportExcelCount(data) {
  return request({
    url: '/cloud/delivery/schedule/live/import/order/parse/count',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 批量导入直播班级订单入班
export function batchImportOrder(data) {
  return request({
    url: '/cloud/delivery/schedule/live/import/order/import',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 查询导入直播班级订单记录
export function getImportOrderRecords(params) {
  return request({
    url: '/cloud/delivery/schedule/live/import/order/import/record',
    method: 'GET',
    params
  })
}

// 查询导入直播班级订单记录详情
export function getImportOrderRecordDetails(params) {
  return request({
    url: '/cloud/delivery/schedule/live/import/order/import/record/details',
    method: 'GET',
    params
  })
}

// 根据商品ID获取班期列表
export function getScheduleUnfinishedList(goodsId) {
  return request({
    url: `/cloud/delivery/schedule/unfinished/list/2/${goodsId}/1`,
    method: 'get'
  })
}
